// extracted by mini-css-extract-plugin
module.exports = {"block":"chartCountries_block__KvI4O","not_found":"chartCountries_not_found__HuTMK"};